import ApplicationController from '../editor/application_controller';
import { createRequest } from '../helpers/createRequest';

export default class extends ApplicationController {
  static targets = ["display", "editor", "input"]

  startEdit() {
    this.displayTarget.classList.add('hidden');
    this.editorTarget.classList.remove('hidden');
    this.inputTarget.focus();
    this.inputTarget.select();
  }

  cancel() {
    this.editorTarget.classList.add('hidden');
    this.displayTarget.classList.remove('hidden');
    // Reset the input value to the original text
    const descriptionDiv = this.displayTarget.querySelector('.text-gray-600');
    if (descriptionDiv) {
      this.inputTarget.value = descriptionDiv.textContent.trim();
    } else {
      this.inputTarget.value = '';
    }
  }

  async save() {
    const description = this.inputTarget.value.trim();

    const formData = new FormData();
    formData.append('x1_description', description);

    // Get studio ID and section ID from dataset
    const studioId = this.element.dataset["x1-DescriptionStudioIdValue"];
    const sectionId = this.element.dataset["x1-DescriptionSectionIdValue"];

    if (!studioId || !sectionId) {
      console.error('Studio ID or Section ID not found', { studioId, sectionId });
      return;
    }

    try {
      const response = await fetch(createRequest(`/x1/studios/${studioId}/sections/${sectionId}/update_description`, 'POST', formData));

      if (response.ok) {
        // Update the display text
        if (description) {
          this.displayTarget.innerHTML = `
            <div class="group flex items-start gap-2 cursor-pointer hover:bg-gray-50 py-2 rounded transition-colors" data-action="click->x1--description#startEdit">
              <svg class="w-4 h-4 text-gray-400 group-hover:text-gray-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
              </svg>
              <div class="text-gray-600 flex-1">
                ${description}
              </div>
            </div>
          `;
        } else {
          this.displayTarget.innerHTML = `
            <div class="border border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                <span class="text-gray-500">No section description yet</span>
              </div>
              <button data-action="click->x1--description#startEdit" class="text-pink hover:text-pink-600 font-medium text-sm transition-colors">
                Add description
              </button>
            </div>
          `;
        }

        // Hide editor, show display
        this.editorTarget.classList.add('hidden');
        this.displayTarget.classList.remove('hidden');
      } else {
        console.error('Failed to update description');
      }
    } catch (error) {
      console.error('Error updating description:', error);
    }
  }
}
